export class Resource {
    dirty: boolean;
}
